/**
 * snake_case -> Title Case for display, e.g. "in_progress" -> "In Progress",
 * "feature_request" -> "Feature Request". Use for dropdown option labels and
 * other plain-text display of enum-ish values.
 *
 * For a p-tag status/priority badge, prefer the anyAsStatusString pipe
 * followed by `| uppercase` instead - this app's tag convention is ALL CAPS
 * (see CLAUDE.md "Status display"), not Title Case.
 */
export function humanizeLabel(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
